/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Ticketpreviewdoorchip3Inputs */

const en_ticketpreviewdoorchip3 = /** @type {(inputs: Ticketpreviewdoorchip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} at the door`)
};

const de_ticketpreviewdoorchip3 = /** @type {(inputs: Ticketpreviewdoorchip3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} vor Ort`)
};

/**
* | output |
* | --- |
* | "{amount} at the door" |
*
* @param {Ticketpreviewdoorchip3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewdoorchip3 = /** @type {((inputs: Ticketpreviewdoorchip3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewdoorchip3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewdoorchip3(inputs)
	return de_ticketpreviewdoorchip3(inputs)
});
export { ticketpreviewdoorchip3 as "ticketPreviewDoorChip" }